<template>
    <b-card>
        <b-alert variant="danger" :show="showAlert">
            {{ alert }}
        </b-alert>
        <b-alert variant="success" :show="showSuccessAlert">
            {{ alert }}
        </b-alert>
        <b-form @submit.prevent="update">
            <b-form-group :label="$t('person.login')" label-cols-sm="3">
                <b-form-input v-model="formData.login" required disabled></b-form-input>
            </b-form-group>
            <b-form-group :label="$t('general.iin')" label-cols-sm="3">
                <b-form-input v-model="formData.newIin" :state="isIinValid" ></b-form-input>
            </b-form-group>
            <b-form-group :label="$t('person.lastname')" label-cols-sm="3">
                <b-form-input v-model="formData.newSurname"></b-form-input>
            </b-form-group>
            <b-form-group :label="$t('person.firstname')" label-cols-sm="3">
                <b-form-input v-model="formData.newFirstName"></b-form-input>
            </b-form-group>
            <b-form-group :label="$t('person.middlename')" label-cols-sm="3">
                <b-form-input v-model="formData.newPatronymic"></b-form-input>
            </b-form-group>
            <b-form-group :label="$t('person.phone')" label-cols-sm="3">
                <the-mask v-model="formData.newPhoneNumber" mask="+7 (7##) ###-##-##"
                    placeholder="+7 (7__) ___-__-__" :masked="true" class="form-control" />
            </b-form-group>
            <hr />
            <b-form-group :label="$t('general.role')" label-cols-sm="3">
                <b-form-select v-model="formData.newRole" required>
                    <option :value="null" disabled>{{ $t('person.selectRole') }}</option>
                    <option v-if="!isAdmin" :value="$appConfig.role.dealer">{{ $t(`role.${$appConfig.role.dealer}`) }}</option>
                    <option v-if="!isAdmin" :value="$appConfig.role.inspector">{{ $t(`role.${$appConfig.role.inspector}`) }}</option>
                    <option v-if="isAdmin" :value="$appConfig.role.admin">{{ $t(`role.${$appConfig.role.admin}`) }}</option>
                    <option v-if="isAdmin" :value="$appConfig.role.operator">{{ $t(`role.${$appConfig.role.operator}`) }}</option>
                </b-form-select>
            </b-form-group>
            <!-- <b-form-group v-if="formData.roleId === $appConfig.role.inspector" :label="$t('kkm.inspectionName')" label-cols-sm="3">
                <b-form-select :options="taxOrgs" v-model="formData.inspection">
                    <template slot="first">
                        <option :value="null" disabled>{{ $t('general.select') }}</option>
                    </template>
                </b-form-select>
            </b-form-group> -->
            <b-form-group :label="$t('person.enabled')" label-cols-sm="3">
                <b-form-checkbox v-model="formData.isActive"></b-form-checkbox>
            </b-form-group>
            <!--<b-form-group :label="$t('person.authType')" label-cols-sm="3">
                <b-form-select v-model="formData.newAuthType" required>
                    <option :value="null" disabled>{{ $t('general.select') }}</option>
                    <option :value="$appConfig.authType.pass.name">{{ $t(`person.authTypes.${$appConfig.authType.pass.id}`) }}</option>
                    <option :value="$appConfig.authType.cert.name">{{ $t(`person.authTypes.${$appConfig.authType.cert.id}`) }}</option>
                    <option :value="$appConfig.authType.certNca.name">{{ $t(`person.authTypes.${$appConfig.authType.certNca.id}`) }}</option>
                </b-form-select>
            </b-form-group>
            <b-form-group :label="$t('person.authKey')" label-cols-sm="3">
                <b-form-input v-model="formData.newAuthKey"></b-form-input>
            </b-form-group>-->
            <b-form-row class="justify-content-end mx-0">
                <b-button type="submit" variant="success" :disabled="isDisabled">
                    <save-icon title="" />&nbsp;{{ $t('general.save') }}
                </b-button>
            </b-form-row>
        </b-form>
    </b-card>
</template>
<script>
/* eslint-disable */
import { isIinValid } from '../../validators/FormValidators';

export default {
    name: 'EditPerson',
    props: {
        personId: Number
    },
    data () {
        return {
            showAlert: false,
            showSuccessAlert: false,
            alert: '',
            formData: {
                login: null,
                newRole: null,
                newFirstName: null,
                newSurname: null,
                newPatronymic: null,
                newPhoneNumber: null,
                isActive: null,
                newAuthType: null,
                newAuthKey: null,
                unlimitedSessionTimeoutEnabled: false,
                newIin: null
                // inspection: null
            },
            selectedDealer: null,
            dealers: [],
            taxInspections: []
        }
    },
    created () {
        this.fetchFormData()
    },
    computed: {
        isDisabled: function () {
            return this.$store.getters.isLoading
        },
        taxOrgs: function () {
            return this.$miscUtil.generateSelectList(this.taxInspections, 'id', 'name')
        },
        isAdmin: function () {
            return this.$store.getters.getUserRole === this.$appConfig.role.admin
        },
        isIinValid: function() {
            return this.formData.newIin != null
                ? isIinValid(this.formData.newIin)
                : null;
        }
    },
    methods: {
        fetchFormData: function () {
            this.$request.sendRequest(this, this.$appConfig.apiUrls.person.getAll,
                { id: this.personId }, result => {
                    const user = result[0];
                    this.formData.login = user.login;
                    this.formData.newRole = user.role;
                    this.formData.newFirstName = user.firstName;
                    this.formData.newSurname = user.surname;
                    this.formData.newPatronymic = user.patronymic;
                    this.formData.newPhoneNumber = user.phoneNumber;
                    this.formData.isActive = user.isActive;
                    this.formData.newAuthKey = user.authKey;
                    this.formData.newIin = user.iin;

                    this.formData.newAuthType = this.$appConfig.authType.pass.id === user.authType
                        ? this.$appConfig.authType.pass.name 
                        : this.$appConfig.authType.cert.name;
                }, this.displayAlert)
        },
        update: function () {
            this.hideAlert()
            if (this.formData.newPhoneNumber) {
                this.formData.newPhoneNumber = this.formData.newPhoneNumber.replace(/\D/g, '')
            }
            this.$request.sendRequest(this, this.$appConfig.apiUrls.person.update,
                this.formData, result => {
                    this.showSuccessAlert = true
                    this.alert = this.$i18n.t('person.updatedMessage')
                }, this.displayAlert)
        },
        hideAlert: function () {
            this.showAlert = false
            this.alert = ''
        },
        displayAlert: function (errorCode) {
            this.alert = this.$i18n.t(`errors.${errorCode}`)
            this.showAlert = true
        }
    }
}
</script>
